<script>
import Slider from './Slider.vue';
export default Slider.extend({
  props: { whiteMode: { type: Boolean } },
});
</script>
<template>
  <div :class="{ 'arrow-dark': whiteMode }" class="c-primary-content-input">
    <vue-slider
      class="mx-auto"
      style="max-width: 460px"
      :min="0"
      :max="10"
      :dotSize="30"
      :height="10"
      tooltip="never"
      :piecewiseLabel="true"
      :bgStyle="{ backgroundColor: 'transparent' }"
      :processStyle="{ backgroundColor: 'transparent' }"
      :sliderStyle="{
        width: '0',
        height: '0',
        borderLeft: '11px solid transparent',
        borderRight: '11px solid transparent',
        borderBottom: '12px solid white',
        borderRadius: '0',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        position: 'absolute',
        top: '28px',
        left: '6px',
      }"
      ref="Slider"
      :value="sValue"
      :labelStyle="{ position: 'absolute', top: '-25px', color: 'white', fontSize: '28px' }"
      @callback="check"
      @drag-start="onDragStart"
    />
  </div>
</template>

<style>
.arrow-dark .vue-slider-piecewise-label {
  color: #343a40 !important;
}
.arrow-dark .vue-slider-dot-handle {
  border-bottom: 12px solid #343a40 !important;
}
</style>
